import { stages } from '../../data/stages';

export const jaStages = stages;
